import React from 'react';
import PropTypes from 'prop-types';
import AdvModal from '../../../CommonComponents/AdvModal';
import { SharingSettings } from '../../../SharingSettings/SharingSettings';
import { Name, ClientOnlineStatus, OnlineIcon } from './ClientMenuStyles';
import ChangeEmailModal from '../ChangeEmailModal';
import { ClientOfflineModal } from '../ClientOfflineModal';
import { AddClientModal } from '../../../AddClientModal/AddClientModal';
import { ClientAccess } from '../../../ClientAccess/ClientAccess';
import { DeleteClientModal } from '../../../DeleteClientModal/DeleteClientModal';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { RawButton } from '../../../CommonComponents/OPL/Button/Button.styles';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
  MenuTriggerItem,
} from '../../../CommonComponents/OPL/Menu/Menu';

class ClientMenuView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isClientAccessOpen: false,
      isCloneClientModalOpen: false,
      isDeleteClientModalOpen: false,
      isChangeEmailModalOpen: false,
      isClientOfflineModalOpen: false,
    };

    this.setIsClientAccessOpen = this.setIsClientAccessOpen.bind(this);
    this.setIsCloneClientModalOpen = this.setIsCloneClientModalOpen.bind(this);
    this.setIsDeleteClientModalOpen = this.setIsDeleteClientModalOpen.bind(this);
    this.openChangeEmailModal = this.openChangeEmailModal.bind(this);
    this.closeChangeEmailModal = this.closeChangeEmailModal.bind(this);
    this.toggleClientOfflineModal = this.toggleClientOfflineModal.bind(this);
  }

  componentDidMount() {
    const { getGliaOnlineStatus, client, showGliaStatus } = this.props;

    if (showGliaStatus) {
      getGliaOnlineStatus(client.Id);
    }
  }

  setIsClientAccessOpen(isOpen) {
    this.setState({ isClientAccessOpen: isOpen });
  }

  setIsCloneClientModalOpen(isOpen) {
    this.setState({ isCloneClientModalOpen: isOpen });
  }

  setIsDeleteClientModalOpen(isOpen) {
    this.setState({ isDeleteClientModalOpen: isOpen });
  }

  toggleClientOfflineModal() {
    const { isClientOfflineModalOpen } = this.state;

    this.setState({ isClientOfflineModalOpen: !isClientOfflineModalOpen });
  }

  openChangeEmailModal() {
    this.setState({ isChangeEmailModalOpen: true });
  }

  closeChangeEmailModal() {
    this.setState({ isChangeEmailModalOpen: false });
  }

  render() {
    const {
      client,
      isDeleteClientEnabled,
      isCurrentPlan,
      downloadPdf,
      resetPlan,
      viewClientActivity,
      viewClientSettings,
      deleteActionLabel,
      sharingCanChangeOwner,
      sharingCanChangeConsumer,
      isSharingSettingsModalOpen,
      openSharingSettingsModal,
      closeSharingSettingsModal,
      modalErrors,
      setModalErrors,
      canInviteConsumer,
      isOnlineGlia,
      showGliaStatus,
      showFinancialPlanning,
    } = this.props;

    const {
      isClientAccessOpen,
      isCloneClientModalOpen,
      isDeleteClientModalOpen,
      isChangeEmailModalOpen,
      isClientOfflineModalOpen,
    } = this.state;

    return (
      <>
        <Box height="100%" display="flex">
          <Menu>
            <MenuTrigger>
              <RawButton>
                <Box
                  display="flex"
                  alignItems="center"
                  width="305px"
                  height="100%"
                  pr="16"
                  style={{ borderRight: '1px solid rgba(151, 151, 151, 0.5)' }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    style={{ width: '100%' }}
                  >
                    <Box display="flex" justifyContent="start" alignItems="center">
                      <Name>
                        {client.FirstName} {client.LastName}
                      </Name>
                    </Box>
                    <Box display="flex" justifyContent="start" alignItems="center">
                      {showGliaStatus && (
                        <ClientOnlineStatus>
                          <OnlineIcon online={isOnlineGlia} />
                          {isOnlineGlia ? 'Online' : 'Offline'}
                        </ClientOnlineStatus>
                      )}
                    </Box>
                  </Box>
                  <Box display="flex" flexDirection="column" justifyContent="space-between">
                    <Icon className="fas fa-caret-down" />
                  </Box>
                </Box>
              </RawButton>
            </MenuTrigger>

            <MenuContent width="305px">
              {client.IsRegistered && (
                <MenuItem onSelect={() => this.setIsClientAccessOpen(true)}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fa fa-cog" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">Manage Client Access</Text>
                  </Box>
                </MenuItem>
              )}

              {!client.IsRegistered && canInviteConsumer && (
                <MenuItem onSelect={() => this.setIsClientAccessOpen(true)}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fas fa-sign-in-alt" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">Invite to Orion Planning</Text>
                  </Box>
                </MenuItem>
              )}

              {showGliaStatus && (
                <MenuItem onSelect={this.toggleClientOfflineModal}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fas fa-desktop" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">CoBrowse with Client</Text>
                  </Box>
                </MenuItem>
              )}

              {showFinancialPlanning && (
                <MenuItem onSelect={() => downloadPdf(client.Id)}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fa fa-download" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">Download Plan PDF</Text>
                  </Box>
                </MenuItem>
              )}

              {!isCurrentPlan && showFinancialPlanning && (
                <MenuItem onSelect={() => resetPlan(client.Id)}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fas fa-sync-alt" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">Reset Financial Plan</Text>
                  </Box>
                </MenuItem>
              )}

              {showFinancialPlanning && (
                <MenuItem onSelect={() => viewClientSettings(client.Id)}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fa fa-user" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">Client Settings</Text>
                  </Box>
                </MenuItem>
              )}

              <MenuItem onSelect={() => viewClientActivity(client.Id)}>
                <Box
                  display="flex"
                  alignItems="center"
                  p="8"
                  css={({ theme }) => ({
                    gap: theme.space['16'],
                  })}
                >
                  <Icon className="fa fa-list-alt" color="neutral.600" fontSize="h6" />
                  <Text color="neutral.600">User Activity</Text>
                </Box>
              </MenuItem>

              <Menu>
                <MenuTriggerItem>
                  <Box
                    display="flex"
                    alignItems="center"
                    p="8"
                    css={({ theme }) => ({
                      gap: theme.space['16'],
                    })}
                  >
                    <Icon className="fa fa-align-left" color="neutral.600" fontSize="h6" />
                    <Text color="neutral.600">More Actions</Text>
                  </Box>
                </MenuTriggerItem>
                <MenuContent sideOffset={0}>
                  {showFinancialPlanning && (
                    <MenuItem onSelect={() => this.setIsCloneClientModalOpen(true)}>
                      <Box
                        display="flex"
                        alignItems="center"
                        p="8"
                        css={({ theme }) => ({
                          gap: theme.space['16'],
                        })}
                      >
                        <Icon className="far fa-copy" color="neutral.600" fontSize="h6" />
                        <Text color="neutral.600">Clone Client</Text>
                      </Box>
                    </MenuItem>
                  )}
                  <MenuItem onSelect={this.openChangeEmailModal}>
                    <Box
                      display="flex"
                      alignItems="center"
                      p="8"
                      css={({ theme }) => ({
                        gap: theme.space['16'],
                      })}
                    >
                      <Icon className="fa fa-envelope" color="neutral.600" fontSize="h6" />
                      <Text color="neutral.600">Change Email Address</Text>
                    </Box>
                  </MenuItem>
                  {(sharingCanChangeOwner || sharingCanChangeConsumer) && (
                    <MenuItem onSelect={openSharingSettingsModal}>
                      <Box
                        display="flex"
                        alignItems="center"
                        p="8"
                        css={({ theme }) => ({
                          gap: theme.space['16'],
                        })}
                      >
                        <Icon className="fas fa-exchange-alt" color="neutral.600" fontSize="h6" />
                        <Text color="neutral.600">Sharing Settings</Text>
                      </Box>
                    </MenuItem>
                  )}
                </MenuContent>
              </Menu>

              {isDeleteClientEnabled && (
                <>
                  <MenuSeparator />
                  <MenuItem onSelect={() => this.setIsDeleteClientModalOpen(true)}>
                    <Box
                      display="flex"
                      alignItems="center"
                      p="8"
                      css={({ theme }) => ({
                        gap: theme.space['16'],
                      })}
                    >
                      <Icon className="far fa-trash-alt" color="error.600" fontSize="h6" />
                      <Text color="error.600">{deleteActionLabel}</Text>
                    </Box>
                  </MenuItem>
                </>
              )}
            </MenuContent>
          </Menu>
        </Box>

        <ChangeEmailModal
          isOpen={isChangeEmailModalOpen}
          onRequestClose={this.closeChangeEmailModal}
          email={client.Email}
          clientId={client.Id}
        />

        {isClientOfflineModalOpen && (
          <ClientOfflineModal
            isOpen
            onRequestClose={this.toggleClientOfflineModal}
            clientName={`${client.FirstName} ${client.LastName}`}
            clientId={client.Id}
          />
        )}

        <AdvModal
          isOpen={isSharingSettingsModalOpen}
          onRequestClose={closeSharingSettingsModal}
          shouldCloseOnOverlayClick={false}
          className="popup sharing-settings-popup"
          overlayClassName="closerdiv"
        >
          {modalErrors && modalErrors.length > 0 ? (
            <div className="confirm">
              <p>
                {modalErrors.map(error => (
                  <div key={error}>{error}</div>
                ))}
              </p>
              <div className="actions">
                <button type="button" onClick={() => setModalErrors([])}>
                  Close
                </button>
              </div>
            </div>
          ) : (
            <SharingSettings clientId={client.Id} onReturn={closeSharingSettingsModal} />
          )}
        </AdvModal>

        {isClientAccessOpen && (
          <ClientAccess
            clientId={client.Id.toString()}
            onClose={() => this.setIsClientAccessOpen(false)}
          />
        )}

        {isCloneClientModalOpen && (
          <AddClientModal
            clientToClone={{
              id: client.Id,
              firstName: client.FirstName,
              lastName: client.LastName,
            }}
            onClose={() => this.setIsCloneClientModalOpen(false)}
          />
        )}

        {isDeleteClientModalOpen && (
          <DeleteClientModal
            clientId={client.Id}
            onClose={() => this.setIsDeleteClientModalOpen(false)}
          />
        )}
      </>
    );
  }
}

ClientMenuView.defaultProps = {
  canInviteConsumer: false,
};

ClientMenuView.propTypes = {
  client: PropTypes.shape({
    Id: PropTypes.number,
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    Email: PropTypes.string,
    IsRegistered: PropTypes.bool,
  }).isRequired,
  isDeleteClientEnabled: PropTypes.bool.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  downloadPdf: PropTypes.func.isRequired,
  resetPlan: PropTypes.func.isRequired,
  viewClientActivity: PropTypes.func.isRequired,
  viewClientSettings: PropTypes.func.isRequired,
  deleteActionLabel: PropTypes.string.isRequired,
  sharingCanChangeOwner: PropTypes.bool.isRequired,
  sharingCanChangeConsumer: PropTypes.bool.isRequired,
  isSharingSettingsModalOpen: PropTypes.bool.isRequired,
  openSharingSettingsModal: PropTypes.func.isRequired,
  closeSharingSettingsModal: PropTypes.func.isRequired,
  modalErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
  setModalErrors: PropTypes.func.isRequired,
  canInviteConsumer: PropTypes.bool,
  isOnlineGlia: PropTypes.bool.isRequired,
  showGliaStatus: PropTypes.bool.isRequired,
  showFinancialPlanning: PropTypes.bool.isRequired,
  getGliaOnlineStatus: PropTypes.func.isRequired,
};

export default ClientMenuView;
